import React from 'react';
import { sanitize } from 'lettersanitizer';

var Letter = /*#__PURE__*/React.memo(function (_ref) {
  var className = _ref.className,
      html = _ref.html,
      iframeTitle = _ref.iframeTitle,
      rewriteExternalLinks = _ref.rewriteExternalLinks,
      rewriteExternalResources = _ref.rewriteExternalResources,
      allowedSchemas = _ref.allowedSchemas,
      preserveCssPriority = _ref.preserveCssPriority,
      text = _ref.text,
      useIframe = _ref.useIframe;
  var sanitizedHtml = sanitize(html, text, {
    rewriteExternalResources: rewriteExternalResources,
    rewriteExternalLinks: rewriteExternalLinks,
    allowedSchemas: allowedSchemas,
    preserveCssPriority: preserveCssPriority
  });

  if (useIframe) {
    return React.createElement("div", {
      className: className
    }, React.createElement("iframe", {
      srcDoc: sanitizedHtml,
      title: iframeTitle
    }));
  }

  return React.createElement("div", {
    className: className,
    dangerouslySetInnerHTML: {
      __html: sanitizedHtml
    }
  });
});

export { Letter };
//# sourceMappingURL=react-letter.esm.js.map
